import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { LanguageSwitcher } from './LanguageSwitcher';

export function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: t('home'), href: '/' },
    { label: t('products'), href: '/products' },
    { label: t('articles'), href: '/article/allchinabuy-spreadsheet-guide' },
    { label: t('reviews'), href: '/article/allchinabuy-review-2026' },
    { label: t('shipping'), href: '/article/allchinabuy-shipping-cost' },
    { label: t('coupon'), href: '/article/allchinabuy-coupon' },
    { label: t('warehouse'), href: '/article/allchinabuy-warehouse-guide' },
    { label: t('legit'), href: '/article/is-allchinabuy-legit' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className={`text-lg md:text-xl font-bold tracking-tight transition-colors ${
              scrolled ? 'text-foreground-950' : 'text-white'
            }`}
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            {t('siteName')}
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  scrolled
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener noreferrer"
              className={`ml-2 px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap ${
                scrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white text-foreground-950 hover:bg-white/90'
              }`}
            >
              {t('buyItNow')}
            </a>
            <div className="ml-3">
              <LanguageSwitcher scrolled={scrolled} />
            </div>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden p-2 rounded-md transition-colors ${
              scrolled ? 'text-foreground-950' : 'text-white'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-background-200/70 shadow-lg">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setMobileOpen(false)}
                className="block px-3 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
              >
                {link.label}
              </Link>
            ))}
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener noreferrer"
              className="block mt-2 px-4 py-2.5 rounded-full text-sm font-semibold bg-primary-500 text-white text-center"
            >
              {t('buyItNow')}
            </a>
            <div className="pt-2">
              <LanguageSwitcher scrolled />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}